// ─────────────────────────────────────────────
// VISUWORKS — Projects Content
// Edit this file to add/change/remove projects.
// Layout code does not need changes.
// ─────────────────────────────────────────────

export const categories = [
  { value: 'alle', label: 'Alle' },
  { value: 'mobilität', label: 'Mobilität' },
  { value: 'architektur', label: 'Architektur' },
  { value: 'kommunikation', label: 'Kommunikation' },
  { value: 'event', label: 'Event' },
  { value: 'design', label: 'Design' },
];

export const projects = [
  {
    id: 1,
    slug: 'Flottenbranding',
    category: 'mobilität',
    title: 'Flottenbranding',
    shortDesc: '20+ Fahrzeuge im einheitlichen Design',
    tags: ['Flotte', 'Folierung', 'B2B'],
    client: 'Manke Brandschutz',
    scope: 'Flottenbranding 20+ Fahrzeuge',
    location: 'Deutschland',
    year: '2024',
    featured: true,
    challenge: 'Ein führendes Brandschutzunternehmen benötigte eine einheitliche visuelle Identität für seine gesamte Fahrzeugflotte von über 20 Fahrzeugen, verteilt auf mehrere Standorte in Deutschland.',
    solution: 'Entwicklung eines modularen Designsystems, das sowohl auf PKW als auch auf Transporter anwendbar ist. Zentrale Koordination aller Folierungsarbeiten mit einheitlichen Qualitätsstandards.',
    implementation: 'Rollout in drei Phasen über 6 Monate. Jedes Fahrzeug wurde vor Ort foliert, um Ausfallzeiten zu minimieren. Dokumentation aller Arbeiten für zukünftige Fahrzeugzugänge.',
    result: 'Einheitliches Erscheinungsbild der gesamten Flotte. 40% höhere Markenwahrnehmung laut Kundenbefragung. Designmanual für zukünftige Fahrzeuge erstellt.',
  },
  {
    id: 2,
    slug: 'Lackschutz',
    category: 'mobilität',
    title: 'PPF Porsche 911',
    shortDesc: 'Vollschutz mit Premium-Lackschutzfolie',
    tags: ['Schutz', 'Premium'],
    client: 'Privatkunde',
    scope: 'Vollfolierung PPF',
    location: 'Düsseldorf',
    year: '2024',
    featured: true,
    challenge: 'Vollständiger Lackschutz für einen neuen Porsche 911 GT3 mit komplexen Karosserieformen und aerodynamischen Elementen.',
    solution: 'Einsatz von Premium STEK Lackschutzfolie mit selbstheilenden Eigenschaften. Präzise Verarbeitung aller Kanten und Übergänge.',
    implementation: 'Detaillierte Vorbereitung der Lackoberfläche. Millimetergenaue Verarbeitung über 5 Arbeitstage. Finale Qualitätskontrolle unter Speziallicht.',
    result: 'Unsichtbarer Vollschutz des Fahrzeugs. 10 Jahre Garantie auf Material. Werterhalt des Fahrzeugs langfristig gesichert.',
  },
  {
    id: 3,
    slug: 'designfolierung',
    category: 'mobilität',
    title: 'Designfolierung',
    shortDesc: 'Individuelle Vollfolierung mit Matt-Finish',
    tags: ['Design', 'Matt'],
    client: 'Privatkunde',
    scope: 'Design & Vollfolierung',
    location: 'Düsseldorf',
    year: '2024',
    featured: false,
    challenge: 'Transformation in ein individuelles Design-Statement mit Premium-Mattfolierung.',
    solution: 'Entwicklung eines exklusiven Farbkonzepts in Satin Black mit Akzenten. Hochwertige 3M 2080 Folie für langlebiges Ergebnis.',
    implementation: 'Komplette Demontage aller Anbauteile. Präzise Verarbeitung aller Flächen. Professionelle Remontage.',
    result: 'Einzigartiges Erscheinungsbild. Hoher Wiedererkennungswert. Volle Reversibilität zum Originallack.',
  },
  {
    id: 4,
    slug: 'flottenbranding',
    category: 'mobilität',
    title: 'Flottenbranding Logistik',
    shortDesc: 'Europaweiter Rollout für Spedition',
    tags: ['100+ Fahrzeuge', 'EU'],
    client: 'Internationale Spedition',
    scope: 'Europaweites Flottenbranding',
    location: 'Europa',
    year: '2023',
    featured: false,
    challenge: 'Einheitliches Branding einer internationalen Spedition mit Standorten in 8 europäischen Ländern.',
    solution: 'Zentrales Projektmanagement mit lokalen Umsetzungspartnern. Einheitliche Materialspezifikationen und Qualitätsstandards.',
    implementation: 'Koordination über 12 Monate. Schulung lokaler Teams. Zentrale Qualitätskontrolle.',
    result: 'Konsistentes Markenbild europaweit. Effiziente Rollout-Struktur für zukünftige Erweiterungen.',
  },
  {
    id: 5,
    slug: 'headquarters-tech-konzern',
    category: 'architektur',
    title: 'Headquarters Tech-Konzern',
    shortDesc: 'Glasfolierung und Leitsystem',
    tags: ['Office', 'Glas'],
    client: 'Tech-Unternehmen',
    scope: 'Interior Branding & Leitsystem',
    location: 'Frankfurt',
    year: '2024',
    featured: true,
    challenge: 'Gestaltung eines modernen Tech-Headquarters mit Fokus auf Transparenz und Markenidentität.',
    solution: 'Kombination aus dekorativen und funktionalen Glasfolierungen. Entwicklung eines digitalen Leitsystems mit analoger Backup-Beschilderung.',
    implementation: 'Umsetzung über 8 Wochen während laufendem Betrieb. Nacht- und Wochenendarbeiten zur Minimierung von Störungen.',
    result: 'Moderne Arbeitsumgebung mit starker Markenidentität. Intuitive Orientierung für Mitarbeiter und Besucher.',
  },
  {
    id: 6,
    slug: 'flagship-store-modemarke',
    category: 'architektur',
    title: 'Flagship Store Modemarke',
    shortDesc: 'Interior Branding und Oberflächenveredelung',
    tags: ['Retail', 'Interior'],
    client: 'Internationale Modemarke',
    scope: 'Komplettes Interior Branding',
    location: 'Düsseldorf',
    year: '2024',
    featured: false,
    challenge: 'Premium-Retail-Umgebung für eine internationale Modemarke.',
    solution: 'Einsatz von Di-Noc Architekturfolien für Oberflächen. Individuell angefertigte Wandgrafiken.',
    implementation: 'Detaillierte Materialabstimmung. Umsetzung in 6 Wochen. Schulung des Store-Personals.',
    result: 'Hochwertige Retail-Umgebung. Vorlage für weitere Store-Rollouts.',
  },
  {
    id: 7,
    slug: 'dental-zentrum-muenchen',
    category: 'architektur',
    title: 'Dental-Zentrum München',
    shortDesc: 'Sichtschutzfolien und Ambiente-Gestaltung',
    tags: ['Praxis', 'Sichtschutz'],
    client: 'Zahnärztliche Gemeinschaftspraxis',
    scope: 'Raumgestaltung & Sichtschutz',
    location: 'München',
    year: '2023',
    featured: false,
    challenge: 'Patientenfreundliche Atmosphäre mit professioneller Ausstrahlung.',
    solution: 'Milchglasfolierungen mit dezenten Designelementen. Beruhigende Farbgestaltung.',
    implementation: 'Umsetzung außerhalb der Praxiszeiten.',
    result: 'Angenehme Patientenumgebung. Funktionaler Sichtschutz. Pflegeleichte Oberflächen.',
  },
  {
    id: 8,
    slug: 'showroom-premium-autohaus',
    category: 'architektur',
    title: 'Showroom Premium-Autohaus',
    shortDesc: 'Komplette Markenraum-Gestaltung',
    tags: ['Showroom', 'Premium'],
    client: 'Premium-Autohaus',
    scope: 'Showroom-Gestaltung',
    location: 'Düsseldorf',
    year: '2024',
    featured: false,
    challenge: 'Markenkonformer Showroom für Premium-Fahrzeuge.',
    solution: 'Großformatige Wandgrafiken. Elegante Glasgestaltung. Hochwertige Bodenfolierung.',
    implementation: 'Phasenweise Umsetzung. Koordination mit Fahrzeuglieferungen.',
    result: 'Einladender Showroom. Steigerung der Kundenverweildauer.',
  },
  {
    id: 9,
    slug: 'messestand',
    category: 'kommunikation',
    title: 'Messestand',
    shortDesc: '800m² Standfläche, komplette Ausstattung',
    tags: ['Messe', '800m²'],
    client: 'Pharmaunternehmen',
    scope: 'Kompletter Messestand',
    location: 'Frankfurt',
    year: '2023',
    featured: true,
    challenge: 'Realisierung eines 800m² Messestands.',
    solution: 'Full-Service von Konzeption bis Abbau. Premium-Materialien für alle Grafikanwendungen.',
    implementation: 'Produktion über 8 Wochen. Aufbau in 5 Tagen. 24/7-Betreuung während der Messe.',
    result: 'Über 10.000 Standbesucher. Award für besten Standbau.',
  },
  {
    id: 10,
    slug: 'produktlaunch-automobil',
    category: 'kommunikation',
    title: 'Produktlaunch Automobil',
    shortDesc: 'Event-Grafik und Inszenierung',
    tags: ['Event', 'Launch'],
    client: 'Automobilhersteller',
    scope: 'Launch-Event Grafik',
    location: 'Berlin',
    year: '2024',
    featured: false,
    challenge: 'Visuelle Inszenierung eines Fahrzeug-Launches vor 500 Gästen.',
    solution: 'Großformatige LED-Inhalte. Physische Grafikelemente.',
    implementation: 'Enge Abstimmung mit Event-Regie. Aufbau 48h vor Event.',
    result: 'Beeindruckende Fahrzeugpräsentation. Positive Presseberichterstattung.',
  },
  {
    id: 11,
    slug: 'fassadenwerbung-innenstadt',
    category: 'kommunikation',
    title: 'Fassadenwerbung Innenstadtlage',
    shortDesc: '300m² beleuchtete Außenwerbung',
    tags: ['Outdoor', 'XXL'],
    client: 'Retail-Unternehmen',
    scope: 'Großflächenwerbung',
    location: 'Köln',
    year: '2024',
    featured: false,
    challenge: '300m² Fassadenwerbung in frequentierter Innenstadtlage.',
    solution: 'Mesh-Banner für optimale Windlast. Integrierte LED-Beleuchtung.',
    implementation: 'Montage durch Industriekletterer.',
    result: 'Hohe Sichtbarkeit. Messbare Steigerung der Filialfrequenz.',
  },
  {
    id: 12,
    slug: 'pos-systeme-retail-kette',
    category: 'kommunikation',
    title: 'POS-Systeme Retail-Kette',
    shortDesc: 'Bundesweiter Rollout Verkaufsständer',
    tags: ['POS', 'Rollout'],
    client: 'Retail-Kette',
    scope: 'POS-Systeme bundesweit',
    location: 'Deutschland',
    year: '2023',
    featured: false,
    challenge: 'Einheitliche POS-Systeme für 200 Filialen bundesweit.',
    solution: 'Entwicklung modularer Displayssysteme. Zentrale Produktion.',
    implementation: 'Rollout über 4 Monate. Schulung Filialpersonal.',
    result: 'Konsistentes Markenerlebnis. Einfache Wartung.',
  },
  {
    id: 13,
    slug: 'ci-entwicklung-startup',
    category: 'design',
    title: 'CI-Entwicklung Startup',
    shortDesc: 'Logo, Styleguide und Anwendungen',
    tags: ['CI', 'Branding'],
    client: 'Tech-Startup',
    scope: 'Corporate Identity',
    location: 'Berlin',
    year: '2024',
    featured: false,
    challenge: 'Vollständige Corporate Identity für ein junges Tech-Startup.',
    solution: 'Logo-Entwicklung. Farbsystem. Typografie. Umfassender Styleguide.',
    implementation: 'Iterativer Designprozess. Enge Abstimmung mit Gründern.',
    result: 'Starke Markenidentität. Grundlage für alle Kommunikationsmaßnahmen.',
  },
  {
    id: 14,
    slug: '3d-rendering-messestand',
    category: 'design',
    title: '3D-Rendering Messestand',
    shortDesc: 'Fotorealistische Visualisierung',
    tags: ['3D', 'Rendering'],
    client: 'Messeaussteller',
    scope: '3D-Visualisierung',
    location: 'Remote',
    year: '2024',
    featured: false,
    challenge: 'Fotorealistische Visualisierung eines geplanten Messestands.',
    solution: '3D-Modellierung und Rendering. Verschiedene Perspektiven und Lichtstimmungen.',
    implementation: 'Iterative Abstimmung. Finale High-Resolution Renderings.',
    result: 'Schnelle interne Freigabe. Klare Grundlage für Produktion.',
  },
  {
    id: 15,
    slug: 'flottendesign-richtlinie',
    category: 'design',
    title: 'Flottendesign-Richtlinie',
    shortDesc: 'Design Manual für 200+ Fahrzeuge',
    tags: ['Manual', 'Flotte'],
    client: 'Logistik-Konzern',
    scope: 'Design-Richtlinie',
    location: 'Deutschland',
    year: '2024',
    featured: false,
    challenge: 'Design-Richtlinie für eine Fahrzeugflotte von 200+ Fahrzeugen.',
    solution: 'Modulares Designsystem. Detaillierte Spezifikationen.',
    implementation: 'Analyse aller Fahrzeugtypen. Erstellung des Manuals.',
    result: 'Einheitliche Umsetzungsgrundlage. Effizienter Rollout.',
  },
  {
    id: 16,
    slug: 'konferenz-2000-teilnehmer',
    category: 'event',
    title: 'Konferenz 2000 Teilnehmer',
    shortDesc: 'Komplette Event-Grafik',
    tags: ['Konferenz', 'Großevent'],
    client: 'Wirtschaftsverband',
    scope: 'Event-Grafik komplett',
    location: 'Hamburg',
    year: '2024',
    featured: false,
    challenge: 'Visuelle Ausstattung einer Großkonferenz mit 2000 Teilnehmern.',
    solution: 'Bühnendesign. Beschilderung. Wegeleitsystem. Digitale Screens.',
    implementation: 'Koordination mit Eventagentur. Aufbau 3 Tage vor Event.',
    result: 'Professioneller Event-Auftritt. Positive Teilnehmer-Resonanz.',
  },
  {
    id: 17,
    slug: 'produktpraesentation-luxusmarke',
    category: 'event',
    title: 'Produktpräsentation Luxusmarke',
    shortDesc: 'VIP-Event mit Premium-Ausstattung',
    tags: ['VIP', 'Premium'],
    client: 'Luxusmarke',
    scope: 'VIP-Event Ausstattung',
    location: 'München',
    year: '2024',
    featured: false,
    challenge: 'Exklusive Produktpräsentation für 150 VIP-Gäste.',
    solution: 'Premium-Materialien. Individuelle Grafikproduktion.',
    implementation: 'Enge Abstimmung mit Marke. Höchste Qualitätsstandards.',
    result: 'Exklusives Markenerlebnis. Begeisterte Gäste.',
  },
  {
    id: 18,
    slug: 'firmenjubilaeum-mittelstand',
    category: 'event',
    title: 'Firmenjubiläum Mittelstand',
    shortDesc: 'Festakt und Ausstellung',
    tags: ['Jubiläum', 'B2B'],
    client: 'Mittelständisches Unternehmen',
    scope: 'Jubiläums-Event',
    location: 'Stuttgart',
    year: '2023',
    featured: false,
    challenge: '50-jähriges Firmenjubiläum mit Festakt und Ausstellung.',
    solution: 'Historische Timeline. Interaktive Stationen. Festliche Dekoration.',
    implementation: 'Recherche Unternehmensgeschichte. Aufbau der Ausstellung.',
    result: 'Würdiger Rahmen für Jubiläum.',
  },
];

// ── Helpers ──
export const getProjectBySlug = (slug) => projects.find((p) => p.slug === slug);
export const getFeaturedProjects = () => projects.filter((p) => p.featured);
export const getProjectsByCategory = (cat) => (cat === 'alle' ? projects : projects.filter((p) => p.category === cat));
